import {
    baseUrl,
    isSignedIn,
    getHeaders,
    getMultipartHeaders,
} from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";

export async function NotificationServicesGetNotificationsList(tableFilters) {
    await isSignedIn();

    const query = queryFilter(tableFilters);
    const urlApi = `${baseUrl}/Module/notification/configurations${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function NotificationServicesGetNotificationById(notificationId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/notification/${notificationId}`;

    return axios.get(urlApi, getHeaders());
}

export async function NotificationServicesCreateOrUpdateNotification(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/notification`;

    return axios.post(urlApi, body, getMultipartHeaders());
}

export async function NotificationServicesDeleteNotification(notificationId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/notification/${notificationId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function NotificationServicesGetTooltipsModules() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/notification/tooltips`;

    return axios.get(urlApi, getHeaders());
}

export async function NotificationServicesCreateAndUpdateTooltipModule(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/notification/tooltip`;

    return axios.post(urlApi, body, getMultipartHeaders());
}

export async function NotificationServicesDeleteTooltipModule(moduleId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/notification/tooltip/${moduleId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function NotificationServicesGetDefaultIcons() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/notification/dropdowns/default-icons`;

    return axios.get(urlApi, getHeaders());
}